/**
 * Created by jonas on 2019-08-21.
 */

import {Timeline, TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {HorribleHeroesGameConfig, IHorribleHeroesBigWinRatioConfig} from "../../HorribleHeroesGameConfig";
import {HorribleHeroesGameModuleConfig} from "../../HorribleHeroesGameModuleConfig";
import {HorribleHeroesParsedGameData} from "../../server/data/HorribleHeroesParsedGameData";
import {HorribleHeroesReelSymbol} from "../../symbols/HorribleHeroesReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";

export class WinEnd implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;
    private _hasWin: boolean;
    private _tl: TimelineLite;
    private scatterCount: number;

    /**
     * @constructs
     * @param stagger
     * @param abortStagger
     */
    constructor(stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public prepare(data: HorribleHeroesParsedGameData): void {
        this._hasWin = data.singleWin > 0 && !data.brokeTheBank; // #414
        this.scatterCount = data.scatterCountValue;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: HorribleHeroesParsedGameData): Timeline | null {
        // #548
        HorribleHeroesGameConfig.instance.WIN_ABORT_DELAY = 0;

        // #414
        if (data.brokeTheBank) {
            return null;
        }

        this._tl = new TimelineLite({
            onComplete: () => {
                this._tl.pause();
                this._tl.kill();
                this._tl.clear();
            }
        });

        if (!this._hasWin) {
            if (!data.wasFeatureBuy && this.scatterCount > 2) {
                this._tl.add(() => {
                }, 1);
                //holding for 1sec as mentioned in #200
                return this._tl;
            }
            if (this.scatterCount > 4) {
                this._tl.add(() => {
                }, 1.8);
                //#475 holding till blast  animation is played
            }
            return this._tl;
        }

        if (data.isBigWin) {
            this._tl.add(HorribleHeroesGameModuleConfig.winTextView.end(0.2, 0.2), 0);
        }
        const isTinyOrSmall: boolean = (data.currentWinRatioConfig!.duration === 0), // #331
            displayDuration: number = isTinyOrSmall ? 0.5 : 0.8; // #331

        this._tl.add([
            // #456 -> display duration for bigWin shall be 1.5
            HorribleHeroesGameModuleConfig.countUpView.end(data.singleWin, (data.isBigWin ? 1.5 : displayDuration), 0.2, data, data.currentWinRatioConfig!.type),
            // #332, #333, #355
            () => HorribleHeroesGameModuleConfig.winTextView.showNoOfWaysWonInitialWin(<IHorribleHeroesBigWinRatioConfig>data.currentWinRatioConfig!, data.isBigWin)
        ], 0);

        if (data.isBigWin) {
            this._tl.add(() => HorribleHeroesGameModuleConfig.winTextView.stopAllEffects());
        }

        this._tl.add(() => this.resetAnimations(data!), displayDuration);

        if (!data.wasFeatureBuy && this.scatterCount > 2) {
            this._tl.add(() => {
            }, 1.3);
            //holding for 1.3sec as mentioned in #200
        }
        if (this.scatterCount > 4) {
            this._tl.add(() => {
            }, 2.1);
            //#475 holding till blast  animation is played
        }
        return this._tl;
    }

    /**
     * @inheritDoc
     * @param isActive
     * @param data
     */
    public abort(isActive: boolean, data: HorribleHeroesParsedGameData): Timeline | null {
        let ts: number = 1;
        if (isActive && this._tl && this._tl.timeline) {
            GameRoundManager.detachAndPlayTimeline(this._tl);
            if (data.isBigWin) {
                ts = 1.5;
                this._tl.timeScale(ts);
            }
        } else {
            if (this._hasWin) {
                this.getAnimation(data);
                if (data.isBigWin) {
                    ts = 1.5;
                    this._tl.timeScale(1.5);
                }
            }
        }

        const delay: number = ((this._tl.totalDuration() / ts) - this._tl.time());

        // #318 -> 1st point
        HorribleHeroesGameConfig.instance.ABORT_DELAY = delay;

        // #548
        HorribleHeroesGameConfig.instance.WIN_ABORT_DELAY = delay;

        return null;
    }

    private resetAnimations(pdata: HorribleHeroesParsedGameData): void {
        HorribleHeroesGameModuleConfig.symbolWinAnimation.resetAnimation();

        pdata.getPotentialSymbolPostions.forEach((pos: boolean[], i: number) => {
            for (let j = 0; j < pdata.getGameAreaSizeAfter[i]; j++) {
                const sym: HorribleHeroesReelSymbol = <HorribleHeroesReelSymbol>Reels.getSymbol(i, j)!;
                if (sym) {
                    sym.stopPotentialWin();
                    sym.changeState({
                        state: HorribleHeroesGameConfig.instance.SYMBOL_STATES.normal,
                        setStack: true,
                        fadeInDuration: 0
                    });
                }
            }
        });
    }
}